import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NAV_LINKS = [
  { label: 'nav.topPage', to: '/' },
  { label: 'nav.about', to: '/about' },
  { label: 'nav.business', to: '/business' },
  { label: 'nav.stats', to: '/stats' },
  { label: 'nav.news', to: '/news' },
];

const CONTACT_LINKS = [
  { label: 'nav.contact', to: '/contact' },
  { label: 'footer.privacy', to: '/privacy' },
];

export default function ElegantFooter() {
  const { t } = useTranslation();

  return (
    <footer style={{ background: '#0A192F', borderTop: '1px solid rgba(201, 162, 39, 0.15)' }}>
      {/* Main Footer */}
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-16 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          {/* Brand Column */}
          <div className="md:col-span-5">
            <img
              src="https://storage.readdy-site.link/project_files/b7870d10-3857-48a7-b51c-5ccdd10677e8/15e7caab-e426-467f-932e-5dd53158ad6b_TradFit.png?v=5d09026c2de21274a37f01665a04ce12"
              alt="TradFit株式会社"
              className="h-7 w-auto object-contain"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
            <p
              className="mt-5 text-sm leading-relaxed max-w-sm"
              style={{ color: '#FFFFFF', fontFamily: "'Noto Serif JP', serif" }}
            >
              {t('footerTagline').split('\n').map((line, i, arr) => (
                <span key={i}>{line}{i < arr.length - 1 && <br />}</span>
              ))}
            </p>
            {/* Gold accent line */}
            <div
              className="mt-6 w-12 h-px"
              style={{ background: 'linear-gradient(90deg, #C9A227, transparent)' }}
            />
          </div>

          {/* Navigation Column */}
          <div className="md:col-span-3 md:col-start-7">
            <p
              className="text-xs tracking-widest-plus uppercase mb-5"
              style={{ color: 'rgba(201, 162, 39, 0.7)', fontFamily: "'Inter', sans-serif", fontWeight: 500 }}
            >
              Navigation
            </p>
            <ul className="space-y-3">
              {NAV_LINKS.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm no-underline transition-colors duration-300 cursor-pointer"
                    style={{
                      fontFamily: "'Noto Serif JP', serif",
                      color: '#FFFFFF',
                    }}
                    onMouseEnter={(e) => {
                      (e.currentTarget as HTMLAnchorElement).style.color = '#C9A227';
                    }}
                    onMouseLeave={(e) => {
                      (e.currentTarget as HTMLAnchorElement).style.color = '#FFFFFF';
                    }}
                  >
                    {t(item.label)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Column */}
          <div className="md:col-span-3">
            <p
              className="text-xs tracking-widest-plus uppercase mb-5"
              style={{ color: 'rgba(201, 162, 39, 0.7)', fontFamily: "'Inter', sans-serif", fontWeight: 500 }}
            >
              Contact
            </p>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:info@tradfit.com"
                  className="text-sm no-underline transition-colors duration-300"
                  style={{
                    fontFamily: "'Noto Serif JP', serif",
                    color: '#FFFFFF',
                  }}
                  onMouseEnter={(e) => {
                    (e.currentTarget as HTMLAnchorElement).style.color = '#C9A227';
                  }}
                  onMouseLeave={(e) => {
                    (e.currentTarget as HTMLAnchorElement).style.color = '#FFFFFF';
                  }}
                >
                  info@tradfit.com
                </a>
              </li>
              {CONTACT_LINKS.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm no-underline transition-colors duration-300 cursor-pointer"
                    style={{
                      fontFamily: "'Noto Serif JP', serif",
                      color: '#FFFFFF',
                    }}
                    onMouseEnter={(e) => {
                      (e.currentTarget as HTMLAnchorElement).style.color = '#C9A227';
                    }}
                    onMouseLeave={(e) => {
                      (e.currentTarget as HTMLAnchorElement).style.color = '#FFFFFF';
                    }}
                  >
                    {t(item.label)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div
        className="border-t"
        style={{ borderColor: 'rgba(255,255,255,0.06)' }}
      >
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p
            className="text-xs"
            style={{ color: '#FFFFFF', fontFamily: "'Inter', sans-serif" }}
          >
            {t('footer.copyright')}
          </p>
          <p
            className="text-xs"
            style={{ color: '#FFFFFF', fontFamily: "'Inter', sans-serif" }}
          >
            Tokyo, Japan
          </p>
        </div>
      </div>
    </footer>
  );
}